/** Uniform random 32-bit seed for new games (browser and Node). */
export function randomWordGridSeed(): number {
  const buf = new Uint32Array(1)
  if (typeof globalThis.crypto?.getRandomValues === 'function') {
    globalThis.crypto.getRandomValues(buf)
    return buf[0]!
  }
  return (Math.floor(Math.random() * 0x1_0000_0000) >>> 0)
}

export function normalizeSeed(seed: number | string): number {
  if (typeof seed === 'number' && Number.isFinite(seed)) {
    return seed >>> 0
  }

  const text = String(seed)
  let hash = 2166136261
  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index)
    hash = Math.imul(hash, 16777619)
  }
  return hash >>> 0
}

export function nextRandom(rngState: number) {
  const nextState = (Math.imul(rngState, 1664525) + 1013904223) >>> 0
  return {
    rngState: nextState,
    value: nextState / 0x1_0000_0000,
  }
}

export function nextInteger(rngState: number, maxExclusive: number) {
  const { rngState: nextState, value } = nextRandom(rngState)
  return {
    rngState: nextState,
    value: Math.floor(value * maxExclusive),
  }
}
